import { PasswordFlowForms } from "common-services/features/shared/PasswordFlowForms";
import { toPasswordFlowFormsProps } from "common-services/serializers/serializers";

import { usePasswordLoginFlow } from "./hooks/usePasswordLoginFlow";
import { OrgSelectionForm } from "./OrgSelectionForm";

interface PasswordLoginProps {
  initialEmail?: string;
  onAuthenticated: () => void;
  onCancel: () => void;
}

export const PasswordLogin = ({
  initialEmail,
  onAuthenticated,
  onCancel,
}: PasswordLoginProps) => {
  const flow = usePasswordLoginFlow({ initialEmail, onAuthenticated });

  return (
    <PasswordFlowForms
      {...toPasswordFlowFormsProps(flow, onCancel)}
      renderExtra={() =>
        flow.view.kind === "orgSelection" ? (
          <OrgSelectionForm
            organisations={flow.view.organisations}
            error={flow.error}
            onSubmit={flow.submitOrgSelection}
          />
        ) : null
      }
    />
  );
};
